import { useState } from 'react';
import DesignV3TemplateLibrary from './DesignV3TemplateLibrary';
import DesignV3ProjectAssets from './DesignV3ProjectAssets';
import ContextHelpButton from '../ContextHelpButton';

export default function ProjectDesignTab({ api, project }) {
  const [assetRevision, setAssetRevision] = useState(0);
  if (!project?.id) return null;

  return (
    <div className="pt-1 pb-0 space-y-3" data-testid="project-design-v3-only">
      <div className="flex justify-end"><ContextHelpButton articleId="design-v3-workspace" label="Guida Design V3" /></div>
      <DesignV3TemplateLibrary
        api={api}
        projectId={project.id}
        assetRevision={assetRevision}
        assetsSidebar={
          <DesignV3ProjectAssets
            api={api}
            projectId={project.id}
            onLogoChange={() => setAssetRevision(value => value + 1)}
          />
        }
      />
    </div>
  );
}
